import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VerifyOTPPage } from './verify-otp.page';

const routes: Routes = [
  {
    path: '',
    component: VerifyOTPPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VerifyOTPPageRoutingModule {}
